module.exports = __webpack_public_path__ + "static/media/BG1.a466c673.jpg";